import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import TextInput from '../../components/text-input';
import Select from '../../components/select';
import Sidebar from '../../components/sidebar';
import Fetch from '../../common/fetch.js';
import { Auth } from 'aws-amplify';




class Datacorrect extends Component {
    // declare variables
    constructor(props) {
        super(props);
        this.fetch = new Fetch();
        this.state = {
            isLoaded: false,
            siteInfo: {},

            siteAddress: '',
            sitecity: '',
            sitestate: '',
            sitezip: '',
            buildingFloorArea: '',
            units: '',
            yearBuilt: '',
            pool: '',
            givenName: '',
            familyName: '',
            mailingAddress: '',
            mailingcity: '',
            mailingstate: '',
            mailingzip: '',
            electricHeating: '',
            tenantMeters: '',
            commonAreaMeters: '',
            masterMetered: ''
        };
    }

    // get site info from backend RDS database
    async getSiteInfo() {
        const user = await Auth.currentAuthenticatedUser();
        const { jwtToken } = user.signInUserSession.idToken;

        const url = 'https://mv9av9jew4.execute-api.us-east-1.amazonaws.com/dev/site/info';
        const options = {
            method: 'GET',
            headers: {
                authorization: jwtToken
            }
        };

        return await this.fetch.request(url, options);
    }



    async UNSAFE_componentWillMount() {
        const siteInfo = await this.getSiteInfo();
        // assigning data to variables
        this.setState({
            isLoaded: true,
            siteAddress: siteInfo.address,
            sitecity: '',
            sitestate: '',
            sitezip: '',
            buildingFloorArea: siteInfo.area,
            units: siteInfo.units,
            yearBuilt: siteInfo.year_blt,
            pool: siteInfo.pool === 0 ? 'NO' : 'YES',
            givenName: siteInfo.owner,
            familyName: siteInfo.owner,
            mailingAddress: siteInfo.owner_address,
            mailingcity: '',
            mailingstate: '',
            mailingzip: '',
            electricHeating: null ? 'NO' : 'YES',
            tenantMeters: siteInfo.res_meters,
            commonAreaMeters: siteInfo.non_res_meters,
            masterMetered: siteInfo.master_m === 0 ? 'NO' : 'YES',
        })
    }

    // after user click on submit button, a modal will show
    async handleDataCorr() {
        event.preventDefault();

        if (this.isDataCorrFormValid()) {
            window.$('#myModal').modal('show');
        }

    } // handleDataCorr

    // check whether the input is valid or not
    isDataCorrFormValid() {
        const { sitezip, buildingFloorArea, yearBuilt, mailingzip,
            tenantMeters, commonAreaMeters } = this.state;

        const nonNumber = RegExp('[^0-9 \,]');
        if (sitezip != null) {
            if (nonNumber.test(sitezip)) {
                alert('Input Error: Please Input Zip Without  Characters');
                return false;
            }
        }
        if (buildingFloorArea != null) {
            if (nonNumber.test(buildingFloorArea)) {
                alert('Input Error: Please Building Floor Area Without Characters');
                return false;
            }
        }
        if (yearBuilt != null) {
            if (nonNumber.test(yearBuilt)) {
                alert('Input Error: Please Year Built Without Characters');
                return false;
            }
        }
        if (mailingzip != null) {
            if (nonNumber.test(mailingzip)) {
                alert('Input Error: Please Input Zip Without Characters');
                return false;
            }
        }
        if (tenantMeters != null) {
            if (nonNumber.test(tenantMeters)) {
                alert('Input Error: Please Input Tenant Meters Without Characters');
                return false;
            }
        }
        if (commonAreaMeters != null) {
            if (nonNumber.test(commonAreaMeters)) {
                alert('Input Error: Please Input Common Area Meters Without Characters');
                return false;
            }
        }

        return true;
    }


    render() {
        return (
            <div>

                <Sidebar />

                <div className='container-fluid my-container'>
                    <div className='d-flex h-100 justify-content-center'>
                        <div className='align-self-md-center h-auto w-50 p-4 form-container '>
                            <p className='signup-title'>DATA UPDATE</p>
                            <p style={{ 'color': 'white' }}>Submit any updates to the data.</p>
                            <TextInput textName='SITE ADDRESS' type='text' value={this.state.siteAddress} onChange={(input) => this.setState({ siteAddress: input })} />
                            <TextInput textName='SITE CITY' type='text' value={this.state.sitecity} onChange={(input) => this.setState({ sitecity: input })} />
                            <TextInput textName='SITE STATE' type='text' value={this.state.sitestate} onChange={(input) => this.setState({ sitestate: input })} />
                            <TextInput textName='SITE ZIP' type='number' value={this.state.sitezip} onChange={(input) => this.setState({ sitezip: input })} />

                            <TextInput textName='BUILDING FLOOR AREA(Sq. Ft)' type='text' value={this.state.buildingFloorArea} onChange={(input) => this.setState({ buildingFloorArea: input })} />
                            <TextInput textName='UNITS' type='text' value={this.state.units} onChange={(input) => this.setState({ units: input })} />
                            <TextInput textName='YEAR BUILT' type='number' value={this.state.yearBuilt} onChange={(input) => this.setState({ yearBuilt: input })} />
                            {/* pool is yes or no, use Select component */}
                            <Select textName='POOL' value={this.state.pool} options={['YES', 'NO']} onChange={(input) => this.setState({ pool: input })} />
                            <TextInput textName='OWNER FIRST NAME' type='text' value={this.state.givenName} onChange={(input) => this.setState({ givenName: input })} />
                            <TextInput textName='OWNER LAST NAME' type='text' value={this.state.familyName} onChange={(input) => this.setState({ familyName: input })} />

                            <TextInput textName='MAILING ADDRESS' type='text' value={this.state.mailingAddress} onChange={(input) => this.setState({ mailingAddress: input })} />
                            <TextInput textName='MAILING CITY' type='text' value={this.state.mailingcity} onChange={(input) => this.setState({ mailingcity: input })} />
                            <TextInput textName='MAILING STATE' type='text' value={this.state.mailingstate} onChange={(input) => this.setState({ mailingstate: input })} />
                            <TextInput textName='MAILING ZIP' type='number' value={this.state.mailingzip} onChange={(input) => this.setState({ mailingzip: input })} />

                            <Select textName='ELECTRIC HEATING' value={this.state.electricHeating} options={['YES', 'NO']} onChange={(input) => this.setState({ electricHeating: input })} />
                            <TextInput textName='TENANT METERS' type='number' value={this.state.tenantMeters} onChange={(input) => this.setState({ tenantMeters: input })} />
                            <TextInput textName='COMMON AREA METERS' type='number' value={this.state.commonAreaMeters} onChange={(input) => this.setState({ commonAreaMeters: input })} />
                            {/* master yes or no, use Select component */}
                            <Select textName='MASTER METERED' options={['YES', 'NO']} onChange={(input) => this.setState({ masterMetered: input })} />

                            <button
                                type='button'
                                className='btn btn-info btn-block font-weight-bold'
                                onClick={() => this.handleDataCorr()}
                            >
                                SUBMIT
                            </button>


                            <div className="modal" id="myModal">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h4 className="modal-title">Submission Successful</h4>
                                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                                        </div>
                                        <div className="modal-body">
                                            Thank you! You have successfully submitted Data Update form. Our staff will contact you if the form is approved.
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-info btn-block font-weight-bold" data-dismiss="modal">CLOSE</button>
                                        </div>

                                    </div>
                                </div>
                            </div>


                            <Link to='/dashboard' className=' btn btn-link btn-block font-weight-bold link'>CANCEL (RETURN TO DASHBOARD)</Link>
                        </div>
                    </div>
                </div>



            </div>
        ); // return
    } // render
}
export default withRouter(Datacorrect);


// WEBPACK FOOTER //
// ./src/routes/datacorrect/index.js